export const GET_NOTIFICATION_READALL = '/notifications/readall'
